import Hero from '../../components/LandingPage/Hero/Hero';
import { ServicesSection } from '../../components/LandingPage/FeaturesSlider';
import ContactForm from '../../components/LandingPage/ContactForm/ContactForm';
import OSINTStatisticsSection from '../../components/LandingPage/OSINTStatisticsSection';
import { useTranslation } from 'react-i18next';
import Footer from '../../components/LandingPage/Footer/Footer';

function Home() {
  const { t } = useTranslation();

  return (
    <main className="min-h-screen bg-black text-white">
      <Hero />

      <div className="bg-gradient-to-b from-black via-[#0A192F] to-[#060D1B]">
        <ServicesSection />
        <OSINTStatisticsSection />
        <section className="py-10 sm:py-16 lg:py-20">
          <div className="mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl text-center">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-6">
              {t('home.request_registration')}
            </h2>
            <p className="text-base sm:text-lg text-gray-300 mb-12">
              {t('home.fill_form')}
            </p>
            <ContactForm subtitle={t('home.contact_subtitle')} />
          </div>
        </section>
        <Footer />
      </div>
    </main>
  );
}

export default Home;
